const treeChildren = Vue => {
  const _ = Vue
  let arr = [];
  for (let i = 2; i <= _.maxPeriods; i++) {
    let obj = {};
    obj.title = `${i}期`;
    obj.align = 'center';
    obj.className = `table_info_column_${i}`;
    obj.render = (h, { row }) => {
      return (
        <div>
          <span>{row[_.chilKey][i] ? row[_.chilKey][i] : 0}</span>
        </div>
      );
    };
    arr.push(obj);
  }
  return arr;
};
const ssc = () => {
  let list = Vue => {
    var o = {
      single: '单',
      double: '双',
      big: ' 大',
      small: '小'
    };
    let arr = [
      {
        title: '日期',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 150
      },
      {
        title: `开'${o[Vue.chilKey]}'长龙出现条数`,
        align: 'center',
        className: `table_issueId`,
        width: 150,
        children: treeChildren(Vue)
      }
    ];



    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Meirichanglongtongji/columns/ks.js